import React from 'react'

import { BadgeAccessRender } from '@app/components/renderers'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { SCHEDULE_COLUMN_KEY } from '@app/pages/MonitoringLaunchPage/constants'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap, columnTitleMapSchedule } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ColumnRender } from '@app/types/table'
import type { RegularMonitoringColumns, RegularMonitoringDataSource, RegularMonitoringColumnsSchedule } from '../types'

const getRender = (key: keyof RegularMonitoringColumns): ColumnRender<RegularMonitoringColumns> | undefined => {
  switch (key) {
    case 'isLaunchAccess':
      return function LaunchAccessRender (_, { isLaunchAccess }) {
        return <BadgeAccessRender hasAccess={ isLaunchAccess } />
      }
  }
}

const getColumnsOptions = (): Array<Column<RegularMonitoringColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof RegularMonitoringColumns>

  return columnKeys.map(key => {
    const column: Column<RegularMonitoringColumns> = {
      customEllipsis: CustomEllipsis,
      key,
      render: getRender(key),
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumnsScheduleOptions = (): Array<Column<RegularMonitoringColumnsSchedule>> => {
  const columnKeys = Object.keys(columnTitleMapSchedule) as Array<keyof RegularMonitoringColumnsSchedule>

  return columnKeys.map(key => {
    const column: Column<RegularMonitoringColumnsSchedule> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<RegularMonitoringDataSource>> =>
  [
    ...getColumnsFromMap<RegularMonitoringColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    }),
    {
      key: SCHEDULE_COLUMN_KEY,
      title: 'Расписание/Дедлайны',
      children: [
        ...getColumnsFromMap<RegularMonitoringColumnsSchedule>({
          columnTitleMap: columnTitleMapSchedule,
          options: getColumnsScheduleOptions()
        })
      ]
    }
  ] as Array<Column<RegularMonitoringDataSource>>
